import React from 'react';
import { motion } from 'framer-motion';
import { Package, Truck, ShieldCheck } from 'lucide-react';
export function IncludedSection() {
  const items = [{
    icon: <Package className="w-6 h-6 text-gold-500" data-id="element-124" />,
    text: '1x Gel íntimo Gold Estimulante',
    sub: '(tamaño estándar)'
  }, {
    icon: <Truck className="w-6 h-6 text-gold-500" data-id="element-125" />,
    text: 'Envío discreto',
    sub: '(sin etiquetas ni referencias al contenido)'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-gold-500" data-id="element-126" />,
    text: 'Garantía de 180 días',
    sub: 'con cambio directo'
  }];
  return <section className="w-full bg-dark-900 py-24 px-4 border-b border-white/5" data-id="element-127">
      <div className="max-w-5xl mx-auto" data-id="element-128">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-129">
          QUÉ INCLUYE
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-130">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-800 p-6 rounded-xl border border-white/5 flex flex-col items-center text-center" data-id="element-131">
              <div className="p-3 bg-dark-900 rounded-full mb-4 border border-white/5" data-id="element-132">
                {item.icon}
              </div>
              <h3 className="text-white font-bold text-lg mb-1" data-id="element-133">{item.text}</h3>
              <p className="text-gray-500 text-sm" data-id="element-134">{item.sub}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}